/**
 * LoadingSpinningLogoComponent is a component that displays a spinning logo and a loading text.
 * @returns {JSX.Element} JSX.Element
 */
export const LoadingSpinningLogoComponent = () => {
  return (
    <div
      style={{
        backgroundColor: '#181818',
      }}
      className="dark:bg-defaultbg flex h-screen flex-col items-center justify-center"
    >
      <img
        style={{
          width: '200px',
        }}
        src="/images/logo/logo.png"
        alt="logo"
        className="animate-bounce"
      />
      <p className="animate-pulse text-2xl text-white">Loading...</p>
    </div>
  );
};
